<template>
  <div>
    <b-card class="bg-white rounded-xl">
      <div class="flex justify-between items-center">
        <div>
          <h2 class="text-2xl font-semibold">Products</h2>
        </div>
        <div class="flex"></div>
      </div>
      <b-input-group class="mt-6">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          v-model="search"
          placeholder="Enter Search...."
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
            @click="getAllProduct"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <div class="mt-8" v-if="vendorProds.result.length != 0">
        <ProductsCard
          :item="item"
          v-for="item in vendorProds.result"
          :key="item._id"
          @getAllProduct="getAllProduct"
        />
      </div>
      <div class="mt-9" v-else>No Data</div>
      <b-card-footer class="py-4 d-flex justify-content-end">
        <b-pagination
          v-model="currentPage"
          :total-rows="vendorProds.totalCount"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import ProductsCard from "./components/ProductsCard";
import { mapState } from "vuex";
import AddProductSidebar from "./components/AddProductSidebar";

export default {
  components: {
    ProductsCard,
    AddProductSidebar,
  },
  data() {
    return {
      tableData: [],
      search: "",
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
    };
  },
  watch: {
    async currentPage() {
      await this.getAllProduct();
    },
    search: {
      handler: _.debounce(async function (val) {
        this.getAllProduct();
      }, 500),
    },
  },
  computed: {
    ...mapState("affiliate", {
      products: "products",
      brandData: "brandData",
      vendorProds: "vendorProds",
    }),
  },
  methods: {
    async getAllProduct() {
      try {
        let payload = {
          offset: (this.currentPage - 1) * 10,
        };
        let data = await this.$store.dispatch(
          "affiliate/getVendorProduct",
          payload
        );
        // console.log(data);
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
  },

  async mounted() {
    this.getAllProduct();
    // console.log(this.vendorProds);
  },
};
</script>
<!-- {_id:ObjectId('65852144f2215f0011f93ce3')} -->
